import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { stripTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-carbon-graphite border-y border-carbon-line" data-id="element-276" data-mp="3sq1wvzm5442a">
      <div className="max-w-7xl mx-auto px-4" data-id="element-277" data-mp="3ss4xfdkx5fl9">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-278" data-mp="3nyk3bwmg55rc">
          {stripTestimonials.map((testimonial, index) => <motion.figure key={testimonial.initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.06,
          duration: 0.3
        }} className="bg-carbon border border-gold/25 p-6 rounded-2xl flex flex-col" data-id="element-279" data-mp="5k14jnwb47ti" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-280" data-mp="2had8r4x5gyzw">
                {[...Array(5)].map((_, star) => <StarIcon key={star} size={16} fill="currentColor" data-id="element-281" data-mp="2cdwj26aayckp" data-mpi={star} />)}
              </div>
              <blockquote className="text-mist italic mb-6 text-sm leading-relaxed" data-id="element-282" data-mp="camj4i5wdxwf">
                &quot;{testimonial.text}&quot;
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-auto" data-id="element-283" data-mp="lccj4cdui55t">
                <div className="w-10 h-10 rounded-full border border-gold flex items-center justify-center text-gold font-bold" data-id="element-284" data-mp="q3ucae9mn1g8">
                  {testimonial.initials}
                </div>
                <div data-id="element-285" data-mp="1021o6ip26tbd">
                  <div className="font-bold text-white text-sm" data-id="element-286" data-mp="101ifztp7njaj">{testimonial.name}</div>
                  <div className="text-xs text-smoke" data-id="element-287" data-mp="143dih1ivo2pw">{testimonial.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}